import { type ReactNode } from "react";
import {DisabledIcon} from "src/assets/Icons";
import { DefaultCheckIcon } from "src/assets/Icons";

type Step = {
  label?: ReactNode;
  content?: ReactNode;

  [key: string]: any;
};

type StepStatus = "completed" | "current" | "upcoming" | string;

type StepperProps = {
  steps: Step[];
  currentStep: number;
  onStepChange?: (step: number) => void;
  disabled?: boolean;
  disableNav?: boolean;
  direction?: "horizontal" | "vertical";
  connectorOverlays?: ReactNode[];
  className?: string;
  classNames?: {
    root?: string;
    item?: string;
    step?: string;
    icon?: string;
    label?: string;
    connector?: {
      wrapper?: string;
      rail?: string;
      overlay?: string;
    };
  };
  getStepStatus?: (index: number) => StepStatus;
  renderStepIcon?: (params: { index: number; status: StepStatus; isActive: boolean }) => ReactNode;
  onBack?: () => void;
  backLabel?: ReactNode;
  onBackNode?: ReactNode;
};

const StepCheckIcon = () => (
  <DefaultCheckIcon className="bg-icon-active h-full w-full rounded-full text-icon-inverted" />
);

const defaultRenderIcon = ({ index, status }: { index: number; status: StepStatus }) => {
  if (status === "disabled") {
    return (
      <div className="text-icon-disabled flex h-5 w-5 items-center justify-center rounded-full">
        <DisabledIcon className="h-4 w-4" />
      </div>
    );
  }

  if (status === "completed" || status === "success") {
    return (
      <div className="flex h-4 w-4 items-center justify-center rounded-full">
        <StepCheckIcon />
      </div>
    );
  }

  if (status === "current") {
    return <div className="flex items-center justify-center rounded-full border text-sm p-2 w-6 h-6">{index + 1}</div>;
  }

  if (status === "error") {
    return <div className="flex h-6 w-6 items-center justify-center rounded-full">!</div>;
  }

  return <div className="flex h-6 w-6 items-center justify-center rounded-full border">{index + 1}</div>;
};

export type { Step, StepStatus, StepperProps };
export { DefaultCheckIcon, DisabledIcon, defaultRenderIcon };
